import React, { Component } from 'react';
import { Route } from 'react-router-dom';
import { connect } from 'react-redux';
import PropTypes, { object } from 'prop-types';
import { bindActionCreators } from 'redux';
import { FormattedMessage } from 'react-intl';
import Constants from '../../../definitions/constants';
import TableDescriptors from '../../../definitions/tableDescriptors';
import InterfaceTooling from '../../../tooling/interfaceTooling';
import JavascriptUtilsTooling from '../../../tooling/javascriptUtilsTooling';
import FormatTooling from '../../../tooling/formatTooling';
import EntityTableTooling from '../../../tooling/entityTableTooling';
import { intl } from '../../../locales/localesConfig';
import toastr from 'toastr';

/* Actions */
import * as metricsGroupAdminActions from '../../actions/metricsGroupAdmin/index';
import * as dashboardActions from '../../actions/dashboard/index';

/*Components*/
import FullScreenGlassLoading from '../../components/common/interface/fullScreenGlassLoading';
import EntityHeader from '../../components/common/entity/entityHeader';
import EntityTable from '../../components/common/entity/entityTable';
import FormPopup from '../../components/metricsGroupAdmin/formPopup';
import GlassConfirmPopup from '../../components/common/interface/glassConfirmPopup';
import ErrorLoadingView from '../../components/common/interface/errorLoadingView';
import EtlTransformationsEditorPopup from '../../components/metricsGroupAdmin/etlTransformationsEditorPopup';

const popupIds = {
  closeFormConfirmPopup: "closeFormConfirmPopup",
  etlTransformationsEditorPopup: "etlTransformationsEditorPopup",
  etlDeleteColumnTransformationsConfirmPopup: "etlDeleteColumnTransformationsConfirmPopup",
  etlEditColumnConfirmPopup: "etlEditColumnConfirmPopup"
}

class MetricsGroupAdmin extends Component {
  constructor(props) {
    super(props);
    this.state = {
      topControlsFormData: {
        searchText: '',
        showDisabledEntities: false,
        selectedTags: [],
      },
      searchTimeoutObject: null,
      tableDescriptor: TableDescriptors.metricsGroupList,
      entityApiKey: "metrics_group",
      initialNewEntity: {required: true, use_pivot_column: false, metrics: [],  etl_definition: [], tags: []},
      etlColumnIndexToEdit: null,
      etlColumnNewValue: null,
      formHasChanges: false,
    };
  }
 
  componentDidMount() {
    EntityTableTooling.fetchList(this);
    this.props.actions.getMetricsList();    
    this.props.actions.getTagsList();
  }
  
  componentWillUnmount() {
    this.props.actions.reset();
  }
  
  componentDidUpdate(prevProps) {
    EntityTableTooling.feedbackMessages(this, prevProps, 
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "metricsGroupAdmin.entityNameSingularWithArticle"})),
      FormatTooling.toUpperCaseFirst(intl.formatMessage({id: "metricsGroupAdmin.entityNamePlural"})),
      intl.formatMessage({id: "metricsGroupAdmin.genderVocal"})),
      null,
      null,
      true
  }

  getListQueryParams = (defaultQueryParams) => {
    let newQueryParams = defaultQueryParams;
    let tags_filter = [];
    if(this.state.topControlsFormData.selectedTags.length > 0) {
      tags_filter = this.state.topControlsFormData.selectedTags;
    }
    newQueryParams.tags_filter = tags_filter;
    return newQueryParams;
  }

  handleOnChangeForm = (event) => {
    if(event.currentTarget.dataset.selectlist) {
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let listValue = event.currentTarget.value;
      let isDelete = event.currentTarget.dataset.delete;
      
      let metrics = JavascriptUtilsTooling.deepCopy(
        JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
      );
            
      if(isDelete) { 
        delete metrics[index];
        metrics = metrics.filter(item => item);
        if(metrics.length==0) {
          this.resetETLDefinition();
        }
      } else {
        var metric_finded = this.props.metricsList.data.find(item => item.id==listValue)
        metrics.push({id: listValue, name: metric_finded.name, dimension_string: metric_finded.dimension_string, metric_type: metric_finded.metric_type});
      }
      this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path,metrics);
      this.setState({ formHasChanges: true });
    }
    else if(event.currentTarget.dataset.objectetleditor) {
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValue = JSON.parse(event.currentTarget.dataset.value);
      let isDelete = event.currentTarget.dataset.delete;
      let isEdit = event.currentTarget.dataset.edit;
      let objectDefinition = [];

      if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
        objectDefinition = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
        );
      }
      
      if(isDelete) { 
        this.handleEtlDeleteColumnTransformationsConfirmPopup(event);
        return;
      } else if(isEdit) {
        this.handleEtlEditColumnConfirmPopup(event);
        return;
      } else {
        objectDefinition.push(objectValue);
      }
      this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path, objectDefinition);
      this.setState({ formHasChanges: true });
    }
    else if(event.currentTarget.dataset.tagslist){
      let path = event.currentTarget.dataset.path;
      let index = event.currentTarget.dataset.index;
      let objectValue = event.currentTarget.dataset.value
      let isDelete = event.currentTarget.dataset.delete;
      let objectDefinition = [];
      
      if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
        objectDefinition = JavascriptUtilsTooling.deepCopy(
          JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
        );
      }
      
      if(isDelete) { 
        delete objectDefinition[index];
        objectDefinition = objectDefinition.filter(item => item);
      } else {
        if(objectDefinition.includes(objectValue)) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.error(intl.formatMessage({id: "common.errors.duplicatedTag"}));
        }
        else if(objectDefinition.map(item => item.toLowerCase()).includes(objectValue.toLowerCase())) {
          toastr.options = Constants.interface.tostrOptions;
          toastr.error(intl.formatMessage({id: "common.errors.duplicatedNonCapitalizedTag"}));
        } 
        else{
          objectDefinition.push(objectValue);
        }
      }
      this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path, objectDefinition);
      this.setState({ formHasChanges: true });
    }
    else {
      EntityTableTooling.handleOnChangeForm(this, event);
    }    
  };

  resetETLDefinition = () => {
    this.props.actions.setSaveEntityDataByKey("metrics_group.etl_definition",[]);
  }

  handleOpenColumnETLTransformationsPopup = (index, objectToEdit = null) => {
    if(objectToEdit) {
      let oldEtlEfinition = JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, "metrics_group.etl_definition");
      oldEtlEfinition[index] = objectToEdit;
      this.props.actions.setSaveEntityDataByKey("metrics_group.etl_definition", oldEtlEfinition);
    }
    InterfaceTooling.handleShowPopup(
      null, popupIds.etlTransformationsEditorPopup, this.state, 
      this.setState.bind(this), false, () => {
        this.setState({ etlColumnIndexToEdit: index });
      }
    );
  }

  handleEtlDeleteColumnTransformationsConfirmPopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.etlDeleteColumnTransformationsConfirmPopup, this.state, 
      this.setState.bind(this), false, () => {
        this.setState({ etlColumnIndexToEdit: event.currentTarget.dataset.index });
      }
    );
  }

  handleEtlDeleteColumnTransformations = () => {
    let objectDefinition = JavascriptUtilsTooling.deepCopy(
      JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, "metrics_group.etl_definition")
    );
    delete objectDefinition[this.state.etlColumnIndexToEdit];
    objectDefinition = objectDefinition.filter(item => item);
    this.props.actions.setSaveEntityDataByKey("metrics_group.etl_definition",objectDefinition);
    this.setState({ formHasChanges: true, etlColumnIndexToEdit: null });
    this.handleEtlDeleteColumnTransformationsConfirmPopup();
  }

  handleEtlEditColumnConfirmPopup = (event) => {
    InterfaceTooling.handleShowPopup(
      event, popupIds.etlEditColumnConfirmPopup, this.state, 
      this.setState.bind(this), false, () => {
        this.setState({ etlColumnIndexToEdit: event.currentTarget.dataset.index, etlColumnNewValue: JSON.parse(event.currentTarget.dataset.value) });
      }
    );
  }

  handleEtlEditColumn = () => {
    let objectDefinition = JavascriptUtilsTooling.deepCopy(
      JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, "metrics_group.etl_definition")
    );
    let objectValue = this.state.etlColumnNewValue;
    objectDefinition[this.state.etlColumnIndexToEdit] = objectValue;
    this.props.actions.setSaveEntityDataByKey("metrics_group.etl_definition",objectDefinition);
    this.setState({ formHasChanges: true, etlColumnIndexToEdit: null, etlColumnNewValue: null });
    this.handleEtlEditColumnConfirmPopup();
  }

  handleOnChangeETLTransformations = (event) => {
    let path = event.currentTarget.dataset.path;
    let index = event.currentTarget.dataset.index;
    let objectValue = JSON.parse(event.currentTarget.dataset.value);
    let isDelete = event.currentTarget.dataset.delete;
    let isEdit = event.currentTarget.dataset.edit;
    let objectDefinition = [];
    
    if(JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)) {
      objectDefinition = JavascriptUtilsTooling.deepCopy(
        JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, path)
      );
    }

    if(objectValue.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_MAPPING || 
      object.transformation_type == Constants.selectKeys.metricsGroupEtl.etlTransformations.COLUMN_PIVOT_MAPPING
    ) {
      objectValue.order = 0;
    } 
    else if(!objectValue.order){
      let maxOrder = objectDefinition.reduce((max, item) => {
        return +item.order > max ? +item.order : max;
      }, 0);
      objectValue.order = +maxOrder + 1;
    }
    else{
      objectValue.order = +objectValue.order;
    }
    
    if(isDelete) { 
      delete objectDefinition[index];
      objectDefinition = objectDefinition.filter(item => item);
    } else if(isEdit) {
      objectDefinition = this.handleReOrderETLTransformations(objectDefinition, objectValue.order);
      objectDefinition[index] = objectValue;
    } else {
      objectDefinition = this.handleReOrderETLTransformations(objectDefinition, objectValue.order);
      objectDefinition.push(objectValue);
    }
    this.setState({ formHasChanges: true });
    this.props.actions.setSaveEntityDataByKey(event.currentTarget.dataset.path,objectDefinition);
  }

  handleReOrderETLTransformations = (objectDefinition, newObjectOrder) => {
    let usedPosition = newObjectOrder;
    objectDefinition.map((item, i) => {
      if(i >= (newObjectOrder-1) && item.order==usedPosition) {
        item.order++;
        usedPosition++;
      }
    });
    return objectDefinition;
  }

  render() {
    var loadingView = this.props.list.firstLoading || this.props.metricsList.firstLoading || this.props.tagsList.firstLoading;
    var errorLoadingView = (this.props.list.status !== null && this.props.list.status !== 200) ||
        (this.props.metricsList.status !== null && this.props.metricsList.status !== 200) ||
        (this.props.tagsList.status !== null && this.props.tagsList.status !== 200);
        
    let tagsArray = (this.props.tagsList && this.props.tagsList.status == 200) ? this.props.tagsList.data : [];
    return (
      <section className="dashboard_content_inner_view entity_admin_container metrics_group_admin_container">
        {
          loadingView ? (<FullScreenGlassLoading/>) : 
          errorLoadingView ? (<ErrorLoadingView/>) :
          (
            <section>
              <EntityHeader 
                entityNamePlural={this.state.tableDescriptor.entityNamePlural}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleRefresh={EntityTableTooling.fetchList.bind(null, this)}
              />
              <EntityTable
                entityTableDescriptor={this.state.tableDescriptor}
                data={this.props.list.data}
                loading={this.props.list.loading}
                page={this.props.list.page}
                totalPages={this.props.list.totalPages}
                totalRecords={this.props.list.totalRecords}
                orderBy={this.props.list.orderBy}
                orderByDirection={this.props.list.orderByDirection}
                topControlsFormData={this.state.topControlsFormData}
                handleOnChangeTopControls={EntityTableTooling.handleOnChangeTopControls.bind(null, this)}
                fetchOrderList={EntityTableTooling.fetchListOrder.bind(null, this)}
                fetchListChangePage={EntityTableTooling.fetchListNextPage.bind(null, this)}
                handleShowFormPopup={EntityTableTooling.handleShowFormPopup.bind(null, this)}
                handleDelete={EntityTableTooling.handleDeletePopup.bind(null, this)}
                handleActive={EntityTableTooling.handleActivePopup.bind(null, this)}
                enableTagsSearch={true}
                tagsOptions={tagsArray}
              />
              <FormPopup
                handleShowPopup={EntityTableTooling.handleShowFormPopupWithConfirmOnExit.bind(null, this)}
                handleOnChangeForm={this.handleOnChangeForm}
                handleButton={EntityTableTooling.handleOnSaveForm.bind(null, this)}
                loadingButton={this.props.save.loading}
                fullLoading={this.props.save.loading}
                statusButton={this.props.save.status}
                formData={this.props.save.data}
                metricsList={this.props.metricsList.data}
                errors={this.props.save.errors}
                entityNameSingular={this.state.tableDescriptor.entityNameSingular}
                handleEditColumnETLTransformationsLink={this.handleOpenColumnETLTransformationsPopup}
                popupState={EntityTableTooling.getFormPopupState(this)}
                tagsOptions={tagsArray}
              />
              <EtlTransformationsEditorPopup
                handleShowPopup={this.handleOpenColumnETLTransformationsPopup}
                popupState={this.state[popupIds.etlTransformationsEditorPopup]}
                formData={this.props.save.data}
                metricsList={this.props.metricsList.data}
                onChange={this.handleOnChangeETLTransformations}
                dataPath={ "metrics_group.etl_definition." + this.state.etlColumnIndexToEdit + ".transformations"}
                usePivotColumn={JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data,"metrics_group.use_pivot_column")}
                values={JavascriptUtilsTooling.getObjectStringPathKeyValue(this.props.save.data, "metrics_group.etl_definition." + this.state.etlColumnIndexToEdit + ".transformations")}
                transformationOptions={InterfaceTooling.getSelectArray("selectKeys.metricsGroupEtl.etlTransformations","metricsGroupAdmin.etlColumnsTransformationsEditor.etlTransformationsLabels")}
              />  
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirmTitle"}
                 values={{entityNameSingular: (<FormattedMessage id={"metricsGroupAdmin.entityNameSingular"}/>)}}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.deleteEntityConfirm"}
                 values={{entityNameSingular: (<FormattedMessage id={"metricsGroupAdmin.entityNameSingularWithArticle"}/>)}}
                />)}
                handleConfirm={EntityTableTooling.handleDeleteConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleDeletePopup.bind(null, this)}
                popupState={EntityTableTooling.getDeletePopupState(this)}
                loading={this.props.delete.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirmTitle"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"metricsGroupAdmin.entityNameSingular"}/>),
                    activeAction: this.props.save.data.metrics_group && this.props.save.data.metrics_group.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                confirmText={(<FormattedMessage 
                 id={"common.entity.activeEntityConfirm"}
                 values={{
                    entityNameSingular: (<FormattedMessage id={"metricsGroupAdmin.entityNameSingularWithArticle"}/>),
                    activeAction: this.props.save.data.metrics_group && this.props.save.data.metrics_group.active ?
                      (<FormattedMessage id={"common.entity.activeAction"}/>) :
                      (<FormattedMessage id={"common.entity.deactiveAction"}/>)
                  }}
                />)}
                handleConfirm={EntityTableTooling.handleActiveConfirm.bind(null, this)}
                handleCancel={EntityTableTooling.handleActivePopup.bind(null, this)}
                popupState={EntityTableTooling.getActivePopupState(this)}
                loading={this.props.save.loading}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"common.confirmExitPopupTitle"}/>)}
                confirmText={(<FormattedMessage id={"common.confirmExitPopupDetail"}/>)}
                handleConfirm={InterfaceTooling.handleCloseForm.bind(null, this)}
                handleCancel={InterfaceTooling.handleCloseFormConfirmPopup.bind(null, this)}
                popupState={InterfaceTooling.getCloseFormConfirmPopupState(this)}
                loading={false}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"metricsGroupAdmin.etlDeleteColumnTransformationsTitle"}/>)}
                confirmText={(<FormattedMessage id={"metricsGroupAdmin.etlDeleteColumnTransformations"}/>)}
                handleConfirm={this.handleEtlDeleteColumnTransformations}
                handleCancel={this.handleEtlDeleteColumnTransformationsConfirmPopup}
                popupState={this.state[popupIds.etlDeleteColumnTransformationsConfirmPopup]}
                loading={false}
              />
              <GlassConfirmPopup
                confirmTitle={(<FormattedMessage id={"metricsGroupAdmin.etlEditColumnTransformationsTitle"}/>)}
                confirmText={(<FormattedMessage id={"metricsGroupAdmin.etlEditColumnTransformations"}/>)}
                handleConfirm={this.handleEtlEditColumn}
                handleCancel={this.handleEtlEditColumnConfirmPopup}
                popupState={this.state[popupIds.etlEditColumnConfirmPopup]}
                loading={false}
              />
            </section>
          )
        }
      </section>
    );
  }
}

const mapStateToProps = state => ({
  list: state.reducer.metricsGroupAdmin.list,
  metricsList: state.reducer.metricsGroupAdmin.metricsList,
  save: state.reducer.metricsGroupAdmin.save,
  delete: state.reducer.metricsGroupAdmin.delete,
  tagsList: state.reducer.metricsGroupAdmin.tagsList,
});

const mapDispatchToProps = dispatch => ({
  actions: bindActionCreators(metricsGroupAdminActions, dispatch),
  dashboardActions: bindActionCreators(dashboardActions, dispatch)
});

MetricsGroupAdmin.propTypes = {};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MetricsGroupAdmin);



// WEBPACK FOOTER //
// ./source/client/containers/metricsGroupAdmin/index.jsx